__turbopack_context__.v({
  "grid": "recently-viewed-module-scss-module__G-Qupa__grid",
  "root": "recently-viewed-module-scss-module__G-Qupa__root",
  "title": "recently-viewed-module-scss-module__G-Qupa__title",
});
